import React, { useState } from 'react'

import { CheckIcon } from '~assets/icons'

import './common.less'

interface CheckboxProps {
  initialChecked?: boolean
  inactive?: boolean
  onCheck?: (checked: boolean) => void
}

const Checkbox: React.FC<CheckboxProps> = ({ initialChecked = false, inactive, onCheck }) => {
  const [checked, setChecked] = useState<boolean>(initialChecked)

  const handleCheck = (): void => {
    setChecked(!checked)
    if (onCheck) {
      onCheck(!checked)
    }
  }

  return (
    <div
      className={`checkbox ${checked ? 'active' : 'unchecked'} ${inactive && 'inactive'}`}
      onClick={inactive ? undefined : handleCheck}
    >
      {(checked || inactive) && <CheckIcon width={14} color='var(--white)' />}
    </div>
  )
}

export default Checkbox
